/**
 * HardwareLifecycle.jsx — Subtab IX
 */

import React from "react";
import { ShredderChain } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function HardwareLifecycle() {
  return (
    <article>
      <SubtabHeading roman="IX">Hardware Refresh and Decommissioning</SubtabHeading>
      <ShredderChain />
      <GapBlock>
        GPU hardware ages out on a three-to-five-year cycle. Decommissioned
        hardware contains client data and must be sanitized or destroyed.
      </GapBlock>
      <SolutionLead>
        NIST SP 800-88 Rev. 1 "Purge" or "Destroy" standards as the floor,
        with chain-of-custody throughout.
      </SolutionLead>
      <Body>
        <P>
          Storage media (NVMe SSDs, HDDs, GPU HBM where it persists data) are
          sanitized using cryptographic erasure if the media supports
          self-encrypting drive standards, followed by physical destruction.
          Cryptographic erasure alone is not sufficient for the
          highest-sensitivity data because of theoretical attacks on key
          recovery; CoConsoleX requires physical destruction for any media
          that processed privileged client data.
        </P>
        <P>
          Physical destruction is performed by NSA-listed and approved
          destruction services or through on-site degaussing (for magnetic
          media) and shredding (for solid-state media) using NSA-approved
          shredders that produce particles ≤ 2mm. Destruction is witnessed by
          the supervising attorney, with chain-of-custody documentation
          following federal evidence-handling standards.
        </P>
        <P>
          GPU hardware that doesn't persist data (compute units without local
          storage) can be returned to vendor or resold, but only after
          verification that no model weights or matter data remain in any
          persistent memory. HBM on modern GPUs typically clears on power-down
          but CoConsoleX requires positive verification.
        </P>
        <P>
          Decommissioning records are retained for ten years (the standard
          malpractice claim tail plus margin) and made available to the
          engaging firm and to clients on request. This addresses the
          regulatory examination concern noted below, and it gives the
          engaging firm a defensible answer to discovery requests about
          historical AI infrastructure.
        </P>
      </Body>
    </article>
  );
}
